import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { API } from "../../common/model/objectTypes";
import { recycleBinInfo } from "../../utils/apiDescription/ssr/recycleBin";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { recycleBinReturnRequestParameter, recycleBinReturnResponseBody, secondBaseRequestBody } from "../../utils/ssr/apiObjects";
import { deleteRecycleBinReturnJsonRequestCurl, recycleBinReturnJsonRequestCurl, restoreRecycleBinReturnJsonRequestCurl } from "../../utils/ssr/sampleJsonRequest";
import { recycleBinReturnJsonResponse } from "../../utils/ssr/sampleJsonResponse";

const deleteRecycleBinReturn: API = {
    name: "Delete Recycle Bin Return",
    url: `${API_BASE_URL}/${SSR.RECYCLE_BIN.DELETE_RECYCLE_BIN_RETURN_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: recycleBinInfo.deleteRecycleBin,
    requestBody: secondBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteRecycleBinReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202)
};

const All: API = {
    name: "Recycle Bin Return",
    url: `${API_BASE_URL}/${SSR.RECYCLE_BIN.RECYCLE_BIN_RETURN_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: recycleBinInfo.recycleBinReturn,
    requestBody: recycleBinReturnRequestParameter,
    responseBody: recycleBinReturnResponseBody,
    jsonRequest: recycleBinReturnJsonRequestCurl,
    jsonResponse: recycleBinReturnJsonResponse
};

const restoreRecycleBinReturn: API = {
    name: "Restore Recycle Bin Return",
    url: `${API_BASE_URL}/${SSR.RECYCLE_BIN.RESTORE_RECYCLE_BIN_RETURN_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: recycleBinInfo.restoreRecycleBin,
    requestBody: secondBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: restoreRecycleBinReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
};

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Recycle Bin Return':
            return deleteRecycleBinReturn;
        case 'Restore':
            return restoreRecycleBinReturn;
    }
};
